import axios from 'axios'
import refreshAttribute from '../utils/refreshAttribute'

export default {
  name: 'dynamic-modal',

  events: [
    {
      on: 'click',
      handle (e) {
        e.preventDefault()
        if (!this.el.getAttribute('js-modal-control')) {
          this.request()
        }
      },
    },
  ],

  componentDidMount () {
    this.modalID = this.id = this.props.id
    this.id = this.props.id
  },

  request () {
    axios
      .get(`${this.props.route}/${this.id}`)
      .then((response) => {
        this.createModal(response.data)
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
  },

  createModal (data) {
    const node = document.createElement('div')
    node.classList.add('modal', 'is-hidden')
    node.id = `${this.props.model}-${this.modalID}`
    node.setAttribute('js-modal', '')

    // node.appendChild(stringToHTML(data))
    node.innerHTML = data
    this.el.setAttribute(
      'js-modal-control',
      `{'target': '#${this.props.model}-${this.modalID}'}`,
    )

    document.querySelector('.modals').appendChild(node)
    if (this.props.refreshAttribute) {
      this.props.refreshAttribute.forEach(el => {
        if (node.querySelector(`[${el}]`)) refreshAttribute(el)(node.querySelector(`[${el}]`))
      })
    }
    node.setAttribute(this.props.jsAttribute, '')

    setTimeout(() => {
      this.el.click()
    }, 300)
  },
}
